<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      max-width="390"
      :fullscreen="isMobileView"
    >
      <template v-slot:activator="{ props }">
        <v-layout
          v-bind="props"
          @click="openDialog"
        >
          <slot />
        </v-layout>
      </template>

      <v-card class="border-radius">
        <v-card-title class="title py-3" primary-title>
          <v-layout>
            <v-flex grow xs11 class="dialog-title align-center">
              {{ $tc('message.bizgainOnboarding.choseDesign') }}
            </v-flex>
            <v-flex>
              <v-icon @click="dialog = false" class="justify-end">
                close
              </v-icon>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider class="my-0" />
        <Creatives
          v-if="dialog"
          :creative-templates="creativeTemplates"
          :class="[{'ml-4':$vuetify.breakpoint.xsOnly, 'ml-3 pl-3': !$vuetify.breakpoint.xsOnly}]"
          @setTemplateId="setTemplateId"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { VDialog, VCard, VCardTitle, VIcon, VLayout, VFlex, VDivider } from 'vuetify/lib';
import Creatives from './Creatives.vue';
export default {
  props: ['creativeTemplates'],
  components: {
    VDialog, VCard, VCardTitle, VIcon, VLayout, VFlex, VDivider,
    Creatives
  },
  data () {
    return {
      dialog: false
    }
  },
  computed: {
    isMobileView(){
      if(this.$vuetify.breakpoint.xsOnly){
        return true;
      }
      return false;
    }
  },
  methods: {
    setTemplateId(templateId){
      this.$emit('setTemplateId', templateId);
      this.dialog = false;
    },
    openDialog(){
      this.dialog = true;
    }
  }
}
</script>
<style scoped>
.button-bg{
  background-color: #F5FBFC;
}
.dialog-title{
  font-size: 18px !important;
  font-weight: 600 !important;
  color: var(--v-black-base) !important;
}
::v-deep .v-dialog::-webkit-scrollbar {
  display: none;
}

</style>